import { FlexBox } from '@airship-platform/jam-web/components';
import { LeftArrowIcon } from '@airship-platform/jam-web/icons';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { Category } from '../../../../data-access/products/products.models';

interface CategoriesBreadcrumbProps {
  categories: Category[];
  categoryIds: string[];
  onBreadcrumbClick: (parentCategoryId?: string) => void;
}

const CategoriesBreadcrumb: React.FC<CategoriesBreadcrumbProps> = ({
  categories,
  categoryIds,
  onBreadcrumbClick,
}) => {
  const categoriesBreadcrumb = useMemo(() => {
    let currentCategory = categories.find((c) =>
      categoryIds.includes(c.categoryId)
    );

    const breadcrumb: Category[] = [];
    while (currentCategory) {
      breadcrumb.unshift(currentCategory);
      const parentCategoryId = currentCategory?.parentCategoryId;
      currentCategory = categories.find(
        (c) => c.categoryId === parentCategoryId
      );
    }

    return breadcrumb;
  }, [categories, categoryIds]);

  const handleBackClick = () => {
    const previousCategory = categoriesBreadcrumb.slice(-1).find(Boolean);
    onBreadcrumbClick(previousCategory?.parentCategoryId);
  };

  return (
    <FlexBox
      gap={1}
      alignItems={'center'}
      visibility={categoryIds.length ? 'visible' : 'hidden'}
    >
      <IconButton
        onClick={handleBackClick}
        size="small"
        color="softGray"
        sx={{ alignSelf: 'flex-start' }}
      >
        <LeftArrowIcon width="1.25rem" />
      </IconButton>
      <FlexBox gap={1} flexWrap={'wrap'}>
        {categoriesBreadcrumb.length < 4 ? (
          categoriesBreadcrumb.map((category) => (
            <Chip
              key={category.categoryId}
              label={category.name}
              color="softGray"
              onClick={() => onBreadcrumbClick(category.categoryId)}
            />
          ))
        ) : (
          <>
            <Chip
              label={categoriesBreadcrumb[0].name}
              color="softGray"
              onClick={() =>
                onBreadcrumbClick(categoriesBreadcrumb[0].categoryId)
              }
            />
            <Typography sx={{ alignSelf: 'flex-end' }}>...</Typography>
            <Chip
              label={categoriesBreadcrumb[categoriesBreadcrumb.length - 2].name}
              color="softGray"
              onClick={() =>
                onBreadcrumbClick(
                  categoriesBreadcrumb[categoriesBreadcrumb.length - 2]
                    .categoryId
                )
              }
            />
            <Chip
              label={categoriesBreadcrumb[categoriesBreadcrumb.length - 1].name}
              color="softGray"
              onClick={() =>
                onBreadcrumbClick(
                  categoriesBreadcrumb[categoriesBreadcrumb.length - 1]
                    .categoryId
                )
              }
            />
          </>
        )}
      </FlexBox>
    </FlexBox>
  );
};

export default CategoriesBreadcrumb;
